import React, { useEffect } from 'react';
import AOS from 'aos';
import "aos/dist/aos.css";
import './index.css';
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate
} from 'react-router-dom';

import '../src/i18n.js';
import Home from './pages/Home';
import Contact from './pages/Contact';
import ScrollToTop from './components/ScrollToTop';
import AroundWorld from './pages/AroundWorld';
import NavBar from './components/Navbar/NavBar';
import Products from './pages/Products';
import Blog from './pages/Blog.js';
import Process from './pages/Process';
import Checkout from './pages/Checkout';

function App() {
  // ✅ Initialize animations
  useEffect(() => {
    const aos_init = () => {
      AOS.init({
        once: true,
        duration: 1000,
        easing: 'ease-out-cubic',
      });
    };

    window.addEventListener('load', aos_init);
    return () => window.removeEventListener('load', aos_init);
  }, []);

  // ✅ Handle direct navigation (prevent GoDaddy 404)
  useEffect(() => {
    const isDirectNavigation = window.performance
      ?.getEntriesByType('navigation')
      ?.some(nav => nav.type === 'navigate');

    const currentPath = window.location.pathname;
    const validPaths = ['/', '/story', '/contact', '/products', '/AroundWorld', '/blog', '/process', '/checkout'];

    if (isDirectNavigation && !validPaths.includes(currentPath)) {
      // Redirect invalid direct routes to main site
      window.location.href = 'https://solivera-oil.com';
    }
  }, []);

  return (
    <Router>
      <ScrollToTop />
      <NavBar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/story" element={<Home section="story" />} /> {/* scroll to section */}
        <Route path="/contact" element={<Contact />} /> {/* scroll to section */}
        <Route path="/products" element={<Products />} />
        <Route path="/AroundWorld" element={<AroundWorld />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/process" element={<Process />} />
        <Route path="/checkout" element={<Checkout />} />

        {/* ✅ Fallback for unknown routes */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Router>
  );
}

export default App;
